import { gql } from '@apollo/client';

const GET_MENU = gql`
query GetMenu {
  menus(where: {language: "all"}, first: 50) {
    nodes {
      languageCode
      menuItems (first: 50) {
        nodes {
          url
          parentDatabaseId
          order
          databaseId
          label
        }
      }
    }
  }  
  menuContents(where: {language: "all"}, first: 50) {
    nodes {
      name
      slug
      description
      menuIcon {
        logo {
          node {
            altText
            mediaItemUrl
            title
          }
        }
      }
      languageCode
    }
  }
}`;

export { GET_MENU }